// extracted by mini-css-extract-plugin
module.exports = {"heading":"i_Eq","label":"i_Er"};